import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { Rnd } from 'react-rnd';
import FontAwesome from 'react-fontawesome';

import { roundNumber, copy, trim_canvas } from './functions.js';
// import "ie-array-find-polyfill";

class ResizeTextPreviewLayer extends React.Component {

    textMinWidth = -1;
    textMinHeight = -1;

    constructor(props) {
        super(props);
        this.state = {
            height: null,
            width: null,
            contentLayer: copy(this.props.contentLayer),
            checkMinWidth: -1,
            lastContent: '',
            lastColor: '',
            activeColor: this.props.activeColor,
            activeFont: this.props.activeFont,
            activeDesignerVariants: this.props.activeDesignerVariants,
            contentCanvas: null,
        }

        this.textMinWidth = this.getLayerTextMinWidth();
        this.textMinHeight = this.getLayerTextMinHeight();

        this.handleTextRemove = this.handleTextRemove.bind(this);
        this.handleLayerSelect = this.handleLayerSelect.bind(this);
        this.handleLayerMove = this.handleLayerMove.bind(this);
        this.handleLayerMoveEnd = this.handleLayerMoveEnd.bind(this);
        this.handleLayerResize = this.handleLayerResize.bind(this);
        this.handleLayerResizeEnd = this.handleLayerResizeEnd.bind(this);

        this.testCanvas = document.createElement('canvas');
        this.testCanvas.width = this.props.contentLayer.maxDimensions.height * 2;
        this.testCanvas.height = this.props.contentLayer.maxDimensions.height * 2;
    }

    handleTextRemove(e) {
        this.props.onContentLayerRemove(this.props.contentLayer);
    }

    handleLayerSelect(e) {
        e.preventDefault();
        this.props.onContentLayerSelect(this.props.layerIndex);
    }

    handleLayerResize(e, dir, ref, delta, pos) {

        const layer = this.state.contentLayer;

        layer.dimensions.height = ref.offsetHeight;
        layer.dimensions.width = ref.offsetWidth;
        this.setState({
            contentLayer: layer
        })
    }

    handleLayerResizeEnd(e, dir, ref, delta, pos) {
        const layer = this.state.contentLayer;

        layer.dimensions.height = ref.offsetHeight;
        layer.dimensions.width = ref.offsetWidth;

        this.props.onContentLayerChange(layer);
    }

    handleLayerMove(e, data) {

        const layer = this.state.contentLayer;

        if (data.y >= 0 && data.y <= layer.maxDimensions.height - layer.dimensions.height)
            layer.dimensions.posY = data.y;

        if (data.x >= 0 && data.x <= layer.maxDimensions.width - layer.dimensions.width)
            layer.dimensions.posX = data.x;

        if ((data.y >= 0 && data.y <= layer.maxDimensions.height - layer.dimensions.height)||
            (data.x >= 0 && data.x <= layer.maxDimensions.width - layer.dimensions.width))
        {
            this.setState({
                contentLayer: layer
            })
        }
        else if (this.rnd !== null && this.rnd !== undefined)
        {
            this.rnd.updatePosition({ x: this.props.contentLayer.dimensions.posX, y: this.props.contentLayer.dimensions.posY });
            this.rnd.updateSize({ width: this.props.contentLayer.dimensions.width, height: this.props.contentLayer.dimensions.height });
        }
    }

    handleLayerMoveEnd(e, data) {

        const layer = this.state.contentLayer;

        if ((data.y < 0 || data.y > layer.maxDimensions.height - layer.dimensions.height) ||
            (data.x < 0 && data.x > layer.maxDimensions.width - layer.dimensions.width))
        {
            if (this.rnd !== null && this.rnd !== undefined)
            {
                this.rnd.updatePosition({ x: this.props.contentLayer.dimensions.posX, y: this.props.contentLayer.dimensions.posY });
                this.rnd.updateSize({ width: this.props.contentLayer.dimensions.width, height: this.props.contentLayer.dimensions.height });
            }

            this.setState({
                contentLayer: this.props.contentLayer
            })
        }
        else
        {
            layer.dimensions.posY = data.y;
            layer.dimensions.posX = data.x;

            this.props.onContentLayerChange(layer);
        }
    }

    componentDidMount() {
        if (this.layerResizeWrapper !== undefined && this.layerResizeWrapper !== null)
        {
            const width = this.layerResizeWrapper.clientWidth;
            const height = this.layerResizeWrapper.clientHeight;
    
            if (this.state.width !== width || this.state.height !== height)
            {
                this.setState({
                    height: height,
                    width: width,
                });
            }
        }

        if (this.state.contentLayer.orgMode !== undefined && this.state.contentLayer.orgMode == 'autoscale')
        {
            const dimensionsOrg = copy(this.props.contentLayer.dimensions);
            this.props.perspectiveLayers.forEach(function(layer) {
                if (layer.type == 'symbol' && layer.orgMode == 'autoscale' && layer.content !== null)
                {
                    if (layer.symbolPosition == 'left')
                    {
                        this.props.contentLayer.dimensions.posX += dimensionsOrg.height;
                        this.props.contentLayer.dimensions.width -= dimensionsOrg.height;
                    }
                    else if (layer.symbolPosition == 'right')
                    {
                        this.props.contentLayer.dimensions.width -= dimensionsOrg.height;
                    }
                }
            }, this);

            this.setState({
                contentLayer: this.props.contentLayer
            })
        }
    }

    componentDidUpdate() {


        if (this.layerCanvasWrapper !== undefined && this.layerCanvasWrapper !== null)
        {
            const newLayer = copy(this.props.contentLayer);
            let newWidth = this.state.width;
            let newHeight = this.state.height;
            let lastContent = this.state.lastContent;
            let lastColor = this.state.lastColor;

            if (this.props.contentLayer.content != lastContent || this.state.activeFont.id !== this.props.activeFont.id)
            {
                lastContent = this.props.contentLayer.content;
                const resultCanvas = this.getTextPreviewCanvas();

                newWidth = resultCanvas.width;
                newHeight = resultCanvas.height;

                while (this.layerCanvasWrapper.hasChildNodes()) {
                    this.layerCanvasWrapper.removeChild(this.layerCanvasWrapper.firstChild);
                }
                for (var charI = 0; charI < resultCanvas.words.length; charI++) {
                    this.layerCanvasWrapper.appendChild(resultCanvas.words[charI].canvas);
                }

                this.layerCanvasWrapper.style.width = resultCanvas.width + 'px';

                this.setState({
                    width: newWidth,
                    height: newHeight,
                    lastContent: lastContent,
                    activeFont: this.props.activeFont,
                    checkMinWidth: 1,
                    contentCanvas: resultCanvas,
                });
            }
            else if ((!this.props.colorPerElement && this.state.activeColor !== this.props.activeColor) ||
                (this.props.colorPerElement && this.props.contentLayer.color.color_hex != lastColor))
            {
                if (this.props.colorPerElement)
                    lastColor = this.props.contentLayer.color.color_hex;

                const resultCanvas = this.getTextPreviewCanvas();

                while (this.layerCanvasWrapper.hasChildNodes()) {
                    this.layerCanvasWrapper.removeChild(this.layerCanvasWrapper.firstChild);
                }
                for (var charI = 0; charI < resultCanvas.words.length; charI++) {
                    this.layerCanvasWrapper.appendChild(resultCanvas.words[charI].canvas);
                }

                this.layerCanvasWrapper.style.width = resultCanvas.width + 'px';

                this.setState({
                    activeColor: this.props.activeColor,
                    contentCanvas: resultCanvas,
                    lastColor: lastColor
                });
            }

            if (this.props.designerRenderMode == 'designer' && 
                (this.textMinWidth > newLayer.dimensions.width || this.textMinHeight > newLayer.dimensions.height))
            {
                if (this.textMinWidth > newLayer.dimensions.width)
                {
                    if (newLayer.dimensions.posX + this.textMinWidth > newLayer.maxDimensions.posX + newLayer.maxDimensions.width)
                    {
                        if (newLayer.dimensions.posX - (this.textMinWidth - newLayer.dimensions.width) < newLayer.maxDimensions.posX)
                            newLayer.dimensions.posX = newLayer.maxDimensions.posX;
                        else
                            newLayer.dimensions.posX = newLayer.dimensions.posX - (this.textMinWidth - newLayer.dimensions.width);
                    }
                    newLayer.dimensions.width = this.textMinWidth;
                }

                if (this.textMinHeight > newLayer.dimensions.height)
                {
                    if (newLayer.dimensions.posY + this.textMinHeight > newLayer.maxDimensions.posY + newLayer.maxDimensions.height)
                    {
                        newLayer.dimensions.posY = Math.max(newLayer.dimensions.posY - (this.textMinHeight - newLayer.dimensions.height), newLayer.maxDimensions.posY);
                    }

                    newLayer.dimensions.height = this.textMinHeight;
                }

                if (this.rnd !== null && this.rnd !== undefined)
                {
                    this.rnd.updatePosition({ x: newLayer.dimensions.posX, y: newLayer.dimensions.posY });
                    this.rnd.updateSize({ width: newLayer.dimensions.width, height: newLayer.dimensions.height });
                }
                
                this.props.onContentLayerChange(newLayer);
                this.setState({
                    width: newWidth,
                    height: newHeight,
                    contentLayer: newLayer,
                    lastContent: lastContent
                });
            }
            else if (this.state.width != newWidth || this.state.height != newHeight)
            {
                this.setState({
                    width: newWidth,
                    height: newHeight,
                    contentLayer: newLayer,
                    lastContent: lastContent
                });
            }
            else if (this.state.activeDesignerVariants != this.props.activeDesignerVariants)
            {
                this.setState({
                    activeDesignerVariants: this.props.activeDesignerVariants,
                    checkMinWidth: 1,
                    lastContent: lastContent
                });
            }

            if (this.props.designerRenderMode == 'designer' && this.state.checkMinWidth === 1)
            {
                this.textMinWidth = this.getLayerTextMinWidth();
                this.textMinHeight = this.getLayerTextMinHeight();
                this.setState({
                    checkMinWidth: -1,
                    lastContent: lastContent
                });
            }
        }

        if (this.props.designerRenderMode == 'designer' && this.rnd !== null && this.rnd !== undefined)
        {
            // this.rnd.updateZIndex(this.getLayerZIndex());
        }
    }


    getTextPreviewCanvas()
    {
        const words = this.props.contentLayer.content.split(' ');
        const ctx = this.testCanvas.getContext('2d');
        const textCanvas = { width: 0, height: 0, words: [], content: null};
        
        let startY = -1;

        let renderWords = [];
        for (var wordI = 0; wordI < words.length; wordI++) {
            if (wordI > 0)
                renderWords.push(' ');
                
            renderWords.push(words[wordI]);
        }

        // force full word here for testing till someone complains :)
        renderWords = [this.props.contentLayer.content];
        

        for (var charI = 0; charI < renderWords.length; charI++) {

            const char = renderWords[charI];
            let testChar = char;

            // if text ist empty or space test width with . character
            if (char == '' || char == ' ')
                testChar = '.';

            // render char to cleared canvas
            this.testCanvas.width = this.props.contentLayer.maxDimensions.height * ((char.length + 1) * 1.2);
            ctx.clearRect(0, 0, this.testCanvas.width, this.testCanvas.height);
            ctx.font = this.props.contentLayer.maxDimensions.height + "px " + this.props.activeFont.id;
            ctx.textBaseline = "hanging";
            ctx.fillStyle = this.props.activeColor.color_hex;

            // handle color per element
            if (this.props.contentLayer.color !== null && this.props.contentLayer.color !== undefined &&this.props.contentLayer.color != 'inherit')
            {
                ctx.fillStyle = this.props.contentLayer.color.color_hex;
            }

            ctx.fillText(testChar, this.props.contentLayer.maxDimensions.height, (this.props.contentLayer.maxDimensions.height / 4));

            // get trimmed canvas
            const renderChar = trim_canvas(this.testCanvas, testChar);
            const trimmedCanvas = renderChar.canvas;

            // if char is space add empty canvas
            if (char == ' ' || char == '')
            {
                const copy = document.createElement('canvas').getContext('2d');
                copy.canvas.width = trimmedCanvas.width * 0.7;
                copy.canvas.height = trimmedCanvas.height;

                textCanvas.width += copy.canvas.width;

                textCanvas.words.push({ canvas: copy.canvas, posY: 0, word: ' '});
            }
            else
            {
                // cound total width
                textCanvas.width += trimmedCanvas.width;
 
                // check startY
                if (renderChar.posY !== null && (renderChar.posY < startY || startY == -1))
                    startY = renderChar.posY;
    
                textCanvas.words.push(renderChar);
            }
        }

        let maxHeight = 0;
        for (var rcharI = 0; rcharI < textCanvas.words.length; rcharI++) {
            if (textCanvas.words[rcharI].word != ' ')
            {
                // calc char posY
                const charPosY = (startY - textCanvas.words[rcharI].posY) * -1;

                // check new maxHeight
                if (textCanvas.words[rcharI].canvas.height + charPosY > maxHeight)
                    maxHeight = textCanvas.words[rcharI].canvas.height + charPosY;
                    
                // correct word Y position
                textCanvas.words[rcharI].canvas.style.marginTop = charPosY + 'px';
            }
        }

        textCanvas.height = maxHeight;
        return textCanvas;
    }

    getExportHeightInMm() {
        
        let exportHeightInMm = this.state.contentLayer.exportHeightMm;
        const exportSizeVar = this.props.activeDesignerVariants.find(desvar => {
            return desvar.isExportSize == "1";
        });

        if (exportSizeVar !== null && exportSizeVar !== undefined && exportSizeVar.selectedVar !== null && exportSizeVar.selectedVar.export_sizes.length > 0)
        {
            const exportSize = exportSizeVar.selectedVar.export_sizes.find(es => {
                return es.perspective_id == this.props.activePerspective.id;
            });

            if (exportSize !== null && exportSize !== undefined)
            {
                const varExportWidthInMm = parseFloat(exportSize.export_width_mm);
                if (varExportWidthInMm > 0)
                {
                    exportHeightInMm = parseFloat(varExportWidthInMm * this.state.contentLayer.maxDimensions.height / this.state.contentLayer.maxDimensions.width);
                }
            }
        }

        return exportHeightInMm;
    }

    getLayerTextMinWidth() {

        if (this.state.height !== null && this.state.width !== null && this.state.height !== 0 && this.state.width !== 0)
        {
            const minHeight = this.getLayerTextMinHeight();
            const scaleX = this.state.width / this.state.height;
            let minWidth = minHeight * scaleX;

            if (this.state.contentLayer.maxDimensions.width < minWidth)
                minWidth = this.state.contentLayer.maxDimensions.width;

            return minWidth;
        }
        return 15;
    }


    getLayerTextMinHeight() {
        
        const exportHeightInMm = this.getExportHeightInMm();

        let minTextHeightInMm = 15;
        if (minTextHeightInMm < exportHeightInMm / 5)
            minTextHeightInMm = exportHeightInMm / 5

        if (minTextHeightInMm > 35)
            minTextHeightInMm = 35;

        const minHeight = this.state.contentLayer.maxDimensions.height * minTextHeightInMm / exportHeightInMm;
        if (isNaN(minHeight) || !isFinite(minHeight)) 
            return 15;

        return minHeight;
    }

    isLayerVisible() {
        if (this.props.activePerspective.id != this.state.contentLayer.perspectiveId || 
            this.props.activePerspective.varid != this.state.contentLayer.perspective_varid || 
            this.state.contentLayer.content === '' || 
            this.state.contentLayer.content === null)
        {
            return false;
        }

        return true;
    }

    getLayerZIndex() {
        return (100 - (this.props.layerIndex * 2));
    }

    render() {

        const layerFont = {
            fontFamily: this.props.activeFont.id
        };

        const layerPositionStyle = {
            top: this.state.contentLayer.dimensions.posY.toString() + 'px',
            left: this.state.contentLayer.dimensions.posX.toString()  + 'px',
            zIndex: this.getLayerZIndex()
        }; 

        const layerActiveStyle = {
            width: this.state.contentLayer.dimensions.width,
            height: this.state.contentLayer.dimensions.height,
            top: '0px',
            left: '0px'
        };

        const layerMaxBounds = {
            top: this.state.contentLayer.maxDimensions.posY.toString() + 'px',
            left: this.state.contentLayer.maxDimensions.posX.toString() + 'px',
            width: this.state.contentLayer.maxDimensions.width.toString() + 'px',
            height: this.state.contentLayer.maxDimensions.height.toString() + 'px',
        }


        let layerMoveStyle = {
            width: this.state.contentLayer.dimensions.width,
            height: this.state.contentLayer.dimensions.height,
            top: this.state.contentLayer.dimensions.posX,
            left: this.state.contentLayer.dimensions.posY,
            zIndex: this.getLayerZIndex()
        }

        let layerResize = {};
        if (this.state.width !== null)
        {
            if (this.textMinHeight === -1)
            {
                this.textMinWidth = this.getLayerTextMinWidth();
                this.textMinHeight = this.getLayerTextMinHeight();
            }

            const scaleX = this.state.contentLayer.dimensions.width / this.state.width;
            const scaleY = this.state.contentLayer.dimensions.height / this.state.height;
            
            layerResize.WebkitTransform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.OTransform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.MsTransform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.MozTransform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.transform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.WebkitTransformOrigin = 'top left';
            layerResize.OTransformOrigin = 'top left';
            layerResize.MsTransformOrigin = 'top left';
            layerResize.MozTransformOrigin = 'top left';
            layerResize.transformOrigin = 'top left';
        }

        if (!this.isLayerVisible())
        {
            layerActiveStyle.visibility = 'hidden';
            layerMaxBounds.visibility = 'hidden';
            layerMoveStyle.visibility = 'hidden';
            layerResize.visibility = 'hidden';
        }

        //<canvas ref={r => this.layerTextCanvas = r} className="layer_text_canvas"></canvas>

        return (
            <div className="preview_layer layer_max_bounds" style={layerMaxBounds}>
                <div className="layer_position_wrapper" style={layerPositionStyle}>
                    <div className="layer_resize_wrapper layer_text_resize_wrapper" style={layerResize} ref={ (layerResizeWrapper) => this.layerResizeWrapper = layerResizeWrapper}>
                        <div className="layer_canvas_wrapper" ref={ (layerCanvasWrapper) => this.layerCanvasWrapper = layerCanvasWrapper}></div>
                    </div>
                </div>

                {
                    // Render if props.designerRenderMode is 'designer'
                    this.props.designerRenderMode == 'designer' ?
                    <Rnd
                        style={{ background: 'transparent', zIndex: layerMoveStyle.zIndex }}
                        default={{
                            x: layerMoveStyle.top,
                            y: layerMoveStyle.left,
                            width: layerMoveStyle.width,
                            height: layerMoveStyle.height
                        }}
                        className={"layer_rnd_wrapper" + (this.props.isActiveLayer ? ' active' : '')}
                        ref={c => { this.rnd = c; }}
                        minHeight={this.textMinHeight + 1}
                        minWidth={this.textMinWidth + 1}
                        resizeHandleClasses={{ bottomRight: 'layer_handle layer_resize_handle fa fa-expand fa-flip-horizontal'}}
                        onDrag={this.handleLayerMove}
                        onDragStop={this.handleLayerMoveEnd}
                        onResize={this.handleLayerResize}
                        onResizeStop={this.handleLayerResizeEnd}
                        scale={this.props.responsiveScale}
                        bounds={'parent'}
                        enableResizing={{ top:false, right:false, bottom:false, left:false, topRight:false, bottomRight:true, bottomLeft:false, topLeft:false }}
                    >
                        <div className={"layer_active_wrapper" + (this.props.isActiveLayer ? ' active' : '')} style={layerActiveStyle} onMouseDown={this.handleLayerSelect} >
                            <div className="layer_handle layer_remove_handle" onClick={this.handleTextRemove}> <FontAwesome name='trash' /> </div>
                        </div>
                    </Rnd>
                    : null
                }
            </div>
        );
    }
  }

export default ResizeTextPreviewLayer;




// WEBPACK FOOTER //
// ./src/ResizeTextPreviewLayer.js